export const getAccount = (instance) => {
  return instance()
    .get(`/bank/api/v1/account/accounts-with-onb/`)
    .then((response) => {
      return response?.data;
    });
};

export const getHomeData = (instance) => {
  return instance()
    .get(`/general/api/v1/settings/bankpromotion/`)
    .then((response) => {
      return response?.data;
    });
};

export const getArchive = (instance, id) => {
  return instance()
    .get(`/bank/api/v1/account/onb-archive/${id}/`)
    .then((response) => {
      return response?.data;
    });
};

export const activeBank = (instance, id) => {
  return instance()
    .get(`/bank/api/v1/account/landing/account-activation/${id}/`)
    .then((response) => {
      return response?.data;
    });
};

export const trackPost = (instance, data) => {
  return instance()
    .post(`/onboarding/api/v1/onb/track-post/`, data)
    .then((response) => {
      return response?.data;
    });
};
